import type { SyncRuntimeStatePayload } from "replo-runtime/shared/types";

import * as React from "react";

import {
  selectSyncRuntimeState,
  setSyncRuntimeState,
} from "@v1/reducers/paint-reducer";
import { useEditorDispatch, useEditorSelector } from "@v1/store/store";

export function useSyncRuntimeValue(key: string) {
  const { syncRuntimeState } = useSyncRuntime();

  return syncRuntimeState[key];
}

export function useSyncRuntime() {
  const syncRuntimeState = useEditorSelector(selectSyncRuntimeState);
  const dispatch = useEditorDispatch();

  return {
    syncRuntimeState,
    setSyncRuntimeState: React.useCallback(
      (setSyncRuntimeStatePayload: SyncRuntimeStatePayload) => {
        return dispatch(setSyncRuntimeState(setSyncRuntimeStatePayload));
      },
      [dispatch],
    ),
  };
}
